// src/components/Hero/Hero.js - Optimizirano za LCP
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import BookingModal from "./BookingModal";
import heroImage from "../../assets/img/hero.JPG";
import "./Hero.css";

function Hero() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <section className="hero" id="home">
        {/* Hero Background Image */}
        <img
          src={heroImage}
          alt="Baby Zoo Garden kreativne radionice za djecu - pozadina"
          className="hero-bg-image"
          fetchpriority="high"
          loading="eager"
        />

        {/* Gradient Overlay */}
        <div className="hero-overlay" aria-hidden="true"></div>

        {/* Content */}
        <div className="container hero-container">
          <div className="hero-content">
            <div className="hero-title-box">
              <h1 className="hero-title">ART&FUN Club</h1>
              <p className="hero-slogan">Tamo gdje mašta postaje zabava!</p>
            </div>
            <p className="hero-description">
              Kroz facepainting, slikarske i kreativne radionice, i animacije
              stvaramo sigurno, inspirativno i veselo druženje za djecu.
            </p>
            <div className="hero-buttons">
              <button
                className="btn-primary"
                onClick={openModal}
                aria-label="Otvori prozor za rezervaciju termina"
              >
                <FontAwesomeIcon icon={faCalendarDays} aria-hidden="true" />
                Rezerviraj termin
              </button>
            </div>
          </div>
        </div>
      </section>

      <BookingModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
}

export default Hero;
